import { Form } from "semantic-ui-react";
import { useFormik } from "formik";
import { initialValues, validationSchema } from "./PostForm.form";
import { useAuth } from "../../../../hooks";
import { Post } from "../../../../api";
import { CustomQuillEditor } from "../../../../components/Shared";
import { withEmptyOption } from "../../../../utils";

const postController = new Post();

export function PostForm(props) {
  const { subjectsOptions, onReload, onClose } = props;
  const { accessToken } = useAuth();

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        console.log("Form value:", formValue);

        const response = await postController.createPost(
          accessToken,
          formValue
        );
        console.log("Post created:", response);

        onClose();
      } catch (error) {
        console.error(error);
      }
    },
  });

  return (
    <Form onSubmit={formik.handleSubmit}>
      <Form.Select
        className="edunova-select"
        fluid
        name="type"
        label="Tipo de publicación"
        placeholder="Selecciona un tipo de publicación"
        clearable
        options={withEmptyOption(
          [
            { key: "question", text: "Pregunta", value: "question" },
            { key: "debate", text: "Debate", value: "debate" },
          ],
          "Selecciona un tipo de publicación"
        )}
        onChange={(e, { value }) => formik.setFieldValue("type", value)}
        value={formik.values.type}
        error={formik.errors.type}
      />
      <Form.Select
        className="edunova-select"
        name="subjectId"
        label="Asignatura"
        placeholder="Selecciona una asignatura"
        clearable
        options={withEmptyOption(subjectsOptions, "Selecciona una asignatura")}
        onChange={(e, { value }) => formik.setFieldValue("subjectId", value)}
        value={formik.values.subjectId}
        error={formik.errors.subjectId}
      />
      <Form.Input
        name="title"
        label="Título"
        onChange={formik.handleChange}
        value={formik.values.title}
        error={formik.errors.title}
      />
      <CustomQuillEditor
        className="media-slide__input-content"
        value={formik.values.content}
        onChange={(value) => formik.setFieldValue("content", value)}
      />
      <Form.Button type="submit" primary fluid loading={formik.isSubmitting}>
        Guardar publicación
      </Form.Button>
    </Form>
  );
}
